/**
 * TanStack Query hooks for `advertiser-rbac`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	createRole,
	deleteRole,
	listPerms,
	listRoles,
	advertiserRbacQueryKeys,
	type CreateRoleBody,
	type CreateRoleResponse,
	type DeleteRoleResponse,
	type ListPermsResponse,
	type ListRolesResponse,
} from "./api";

export function useAdvertiserRbacRoles(): UseQueryResult<ListRolesResponse, Error> {
	return useQuery({
		queryKey: advertiserRbacQueryKeys.roles(),
		queryFn: listRoles,
	});
}

export function useAdvertiserRbacPerms(): UseQueryResult<ListPermsResponse, Error> {
	return useQuery({
		queryKey: advertiserRbacQueryKeys.perms(),
		queryFn: listPerms,
	});
}

export function useAdvertiserRbacCreate(): UseMutationResult<
	CreateRoleResponse,
	Error,
	CreateRoleBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: createRole,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: advertiserRbacQueryKeys.all });
		},
	});
}

export function useAdvertiserRbacDelete(): UseMutationResult<
	DeleteRoleResponse,
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: deleteRole,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: advertiserRbacQueryKeys.all });
		},
	});
}
